import React, { useState } from "react"

const ServiceFaq: React.FC = () => {

    // Accordion Active Index
    const [active, setActive] = useState<number>(1);

    const toggleAccordion = (index: number) => {
        setActive(active === index ? -1 : index);
    };

    const faqItems = [
        {
            id: 1,
            title: "01. What stage should my product idea be at to start this service?",
            content:
                "Your idea can be at any stage—from a rough concept or problem statement to an early sketch or reference product. We specialize in shaping unclear ideas into structured, manufacturable concepts.",
        },
        {
            id: 2,
            title: "02. Do you only design the concept, or do you handle full product development?",
            content:
                "Product Concept Design is the first phase of development. However, we can seamlessly continue into detailed engineering, prototyping, and production support if required.",
        },
        {
            id: 3,
            title: "03. How long does the Product Concept Design phase take?",
            content:"The timeline depends on product complexity, but most projects take between 2 to 6 weeks. We define a clear schedule at the start of the project.",
        },
        {
            id: 4,
            title: "04. Can you work with existing products or improve a current design ?",
            content:
                "Absolutely. We can redesign, optimize, or modernize existing products to improve performance, reduce cost, or prepare them for mass production",
        },
    ];


    return (
            <div className="service-process-wrap pt-120 pb-125">
                <div className="row mt-none-50 align-items-center">
                    {/* LEFT SIDE ACCORDION */}
                    <div className="col-lg-6 mt-50">
                        <h2 className="details-content-title mb-40">Service process</h2>

                        <div className="service_process_faq">
                            <div className="accordion">
                                {faqItems.map((item) => (
                                    <div className="accordion-item" key={item.id}>
                                        <div
                                            className={`accordion-button ${active === item.id ? "" : "collapsed"
                                                }`}
                                            role="button"
                                            onClick={() => toggleAccordion(item.id)}
                                        >
                                            {item.title}
                                        </div>

                                        <div
                                            className={`accordion-collapse collapse ${active === item.id ? "show" : ""
                                                }`}
                                        >
                                            <div className="accordion-body">
                                                <p className="m-0">{item.content}</p>
                                            </div>
                                        </div>
                                    </div>
                                ))}
                            </div>
                        </div>
                    </div>

                    {/* RIGHT SIDE CLICKABLE LIST */}
                    <div className="col-lg-6 mt-50">
                        <ul className="content_layer_group list-unstyled">
                            {faqItems.map((item,index) => (
                                <li
                                    key={item.id}
                                    onClick={() => toggleAccordion(item.id)}
                                    className={active === item.id ? "active" : ""}
                                >
                                    <span>{index + 1}</span>
                                </li>
                            ))}
                        </ul>
                    </div>
                </div>
            </div>
    )
}

export default ServiceFaq;
